import React from "react";
import { useTranslation } from "react-i18next";

export const AuthLayout = ({ children, title, description, backButton }) => {
  const { t } = useTranslation();
  return (
    <main className="relative min-h-[100svh] overflow-x-hidden bg-[#F6F7FF] lg:grid lg:grid-cols-[minmax(360px,0.82fr)_minmax(520px,1.18fr)]">
      <div className="pointer-events-none absolute -right-24 -top-28 h-72 w-72 rounded-full bg-[#5865F2]/10 blur-2xl lg:hidden" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-[#FF5F65]/10 blur-2xl lg:hidden" />

      <aside className="relative hidden min-h-[100svh] overflow-hidden bg-[#1E293B] p-12 text-white lg:flex lg:flex-col">
        <div className="absolute -right-24 -top-20 h-80 w-80 rounded-full bg-[#5865F2]/35 blur-2xl" />
        <div className="absolute -bottom-24 -left-20 h-72 w-72 rounded-full bg-[#FF5F65]/25 blur-2xl" />
        <div className="absolute left-[18%] top-[24%] h-44 w-44 rounded-full border border-white/10" />
        <div className="absolute left-[24%] top-[30%] h-28 w-28 rounded-full border border-white/10" />

        <div className="relative z-20 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-lg shadow-black/20">
            <img src="/logo192.png" alt="" className="h-11 w-11" />
          </span>
          <span className="text-sm font-extrabold uppercase tracking-[0.28em]">Pairvio</span>
        </div>

        <div className="relative z-20 my-auto max-w-md">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.24em] text-white/50">Practice before it matters</p>
          <blockquote className="space-y-4">
            <p className="font-display text-4xl leading-tight">
              &ldquo;{t("auth.layout.quote")}&rdquo;
            </p>
            <footer className="text-sm font-semibold text-white/60">{t("auth.layout.quoteAuthor")}</footer>
          </blockquote>
        </div>
      </aside>

      <section className="relative flex min-h-[100svh] w-full items-center justify-center px-4 py-8 sm:px-8 lg:px-12">
        <div className="w-full max-w-[430px] rounded-[28px] border border-[#5865F2]/10 bg-white/95 p-5 shadow-[0_24px_70px_rgba(30,41,59,0.12)] backdrop-blur sm:p-8 lg:border-0 lg:bg-transparent lg:p-0 lg:shadow-none">
          <div className="mb-7 flex flex-col items-center text-center">
            <span className="mb-3 flex h-20 w-20 items-center justify-center overflow-hidden rounded-[24px] border border-[#5865F2]/10 bg-white shadow-[0_12px_30px_rgba(30,41,59,0.13)] lg:hidden">
              <img src="/logo192.png" alt="Pairvio" className="h-20 w-20" />
            </span>
            <span className="mb-5 text-sm font-extrabold uppercase tracking-[0.24em] text-[#1E293B] lg:hidden">Pairvio</span>
            <h1 className="font-display text-3xl font-semibold tracking-tight text-[#1E293B] sm:text-4xl">
              {title}
            </h1>
            <p className="mt-2 max-w-sm text-sm leading-6 text-[#6B7892] sm:text-base">
              {description}
            </p>
          </div>
          {children}
          {backButton}
        </div>
      </section>
    </main>
  );
};
